import { ICommunicationError } from "@dev/hc-talk-talk";
import CheckCredentialsRequest from "@/app/dto/CheckCredentialsRequest";
import ICheckCredentialsResponse from "@/app/dto/ICheckCredentialsResponse";
import ILoginResponse from "@/app/dto/ILoginResponse";
import LoginRequest from "@/app/dto/LoginRequest";
import ApiError from "@/app/model/ApiError";
import OtpData from "@/app/model/OtpData";
import { createSha256HashWith1000Iterations } from "@/app/utils/PwdUtils";
import Api from "@/app/service/api";

class Login {
    public checkCredentials(username: string, password: string): Promise<ICheckCredentialsResponse> {
        return new Promise((resolve, reject) => {
            const request = new CheckCredentialsRequest(
                username.trim(),
                createSha256HashWith1000Iterations(password)
            );
            Api.checkCredentials(request)
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    public login(customerUuid: string, otp: OtpData, authKey: string, password: string): Promise<ILoginResponse> {
        return new Promise((resolve, reject) => {
            Api.login(customerUuid, authKey, otp, createSha256HashWith1000Iterations(password), new LoginRequest())
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }
}

export default new Login();
